import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const benefits = ['Construis des véhicules et des robots à partir de zéro', 'Instructions illustrées étape par étape', 'Niveaux de difficulté : facile, intermédiaire et avancé', 'Compétences STEM : ingénierie, logique et créativité', 'Nouveaux projets ajoutés régulièrement', 'Idéal pour jouer seul ou entre parents et enfants'];
const projects = [{
  img: 'https://cdn.magicpatterns.com/uploads/cBBDxnMb4mJFhDnHyQDyxY/IMG_1070.png',
  alt: 'Projet créatif avec une bouteille et des trombones',
  tone: 'bg-coral-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/85ppJUoEtmvkUbWcpaDyq7/IMG_1069.webp',
  alt: 'Ascenseur en carton avec un feu lumineux',
  tone: 'bg-sky-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/acBuwab2CXMr2jfQVqrpi6/IMG_1068.webp',
  alt: 'Bras robotique programmable',
  tone: 'bg-sunshine-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/oURkoCn4YJBQPNbRdnBCWU/IMG_1067.png',
  alt: 'Distributeur d’eau en carton',
  tone: 'bg-mint-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/wvbckmE64dGniQpkQvKqY8/IMG_1066.png',
  alt: 'Main robotique mécanique',
  tone: 'bg-brand-light'
}];
export function ProjectsCarousel() {
  const prefersReducedMotion = useReducedMotion();
  const loopedProjects = [...projects, ...projects];
  return <section className="w-full overflow-hidden bg-white py-16 sm:py-24" data-id="element-156" data-mp="2q45f6adrezjd">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-157" data-mp="2c3kzvo71zlum">
        <SectionHeading eyebrow="Ce que reçoit votre enfant" title={<>Plus de 100 projets qui fonctionnent vraiment</>} subtitle="Chaque projet est testé, illustré et rédigé dans un langage simple que votre enfant peut suivre — seul ou avec vous." data-id="element-158" data-mp="2c55rb4y2moo9" />
      </div>

      <div className="mt-12 w-full overflow-hidden" aria-label="Une sélection de projets MakerLab" data-id="element-159" data-mp="fa9mm8gkulln">
        <motion.div className="flex w-max gap-3 px-1 sm:gap-5" animate={prefersReducedMotion ? undefined : {
        x: ['0%', '-50%']
      }} transition={prefersReducedMotion ? undefined : {
        duration: 34,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-160" data-mp="8usnzr0q707k">
          {loopedProjects.map((project, index) => <div key={`${project.alt}-${index}`} aria-hidden={index >= projects.length} className={`h-36 w-24 flex-none overflow-hidden rounded-2xl border border-ink/10 shadow-sm sm:h-48 sm:w-36 ${project.tone}`} data-id="element-161" data-mp="mtsd0zs5hh49" data-mpi={index}>
              <img src={project.img} alt={index < projects.length ? project.alt : ''} className="h-full w-full object-cover" data-id="element-162" data-mp="1ak4r6sdzoa3a" />
            </div>)}
        </motion.div>
      </div>

      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-163" data-mp="1mv5o0nactye9">
        <ul className="mt-12 grid gap-x-8 gap-y-4 rounded-3xl border border-ink/10 bg-brand-light p-8 sm:grid-cols-2" data-id="element-164" data-mp="1rtql4dub81yh">
          {benefits.map((benefit, index) => <li key={benefit} className="flex items-start gap-3 text-sm font-medium text-ink" data-id="element-165" data-mp="1wqh1z3dxv1ky" data-mpi={index}>
              <span className={`mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full ${['bg-brand text-white', 'bg-sky text-ink', 'bg-coral text-ink', 'bg-mint text-ink', 'bg-brand text-white', 'bg-sky text-ink'][index]}`} data-id="element-166" data-mp="25sq9dkdwueu4">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="2oj81pnutz8ey" />
              </span>
              {benefit}
            </li>)}
        </ul>
      </div>
    </section>;
}